module.exports = __webpack_public_path__ + "static/media/uifaces-avatar.c4dd7ada.jpg";